import React from 'react';
import _debounce from 'lodash/debounce';

export default baseComponent => {
  const Base = React.createFactory(baseComponent);
  return class Remote extends React.Component<any, any>{
    state = {
      options: {},
      disabled: false
    }
  
    handleChange(value) {
      const { fetch } = this.props;
      const fx = fetch(value);
      if (!!fx.then) {
        return fx
          .then(options => this.setState({ options }))
          .catch(() => this.setState({ disabled: true }))
      } else {
        return this.setState({ options: fx })
      }
    }

    debouncedHandler = _debounce(this.handleChange, 500);

    onChangeSearch = (search) => {
      const { onChangeSearch, debounce } = this.props;
      if (onChangeSearch) onChangeSearch(search);
      !!debounce ? this.debouncedHandler(search) : this.handleChange(search);
    }
  
    componentWillMount() {
      this.handleChange(this.props.value);
    }

    render() {
      return Base({
        ...this.props,
        ...this.state,
        onChangeSearch: this.onChangeSearch
      })
    }
  }
};
